import AnimateOnScroll from "../AnimateOnScroll";
import FastgiverForm from "../FastgiverForm";

interface FastgiverSectionProps {
  heading: string;
  body: string;
}

const FastgiverSection = ({ heading, body }: FastgiverSectionProps) => {
  return (
    <section id="fastgiver" className="mx-auto max-w-6xl px-6 py-12 md:py-16 scroll-mt-20">
      <div className="grid gap-10 md:grid-cols-2 md:items-center">
        <AnimateOnScroll>
          <div>
            <h2 className="text-3xl font-bold md:text-4xl font-heading">
              {heading}
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-muted-foreground font-body">
              {body}
            </p>
          </div>
        </AnimateOnScroll>
        <AnimateOnScroll delay="delay-200">
          <FastgiverForm />
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default FastgiverSection;
